import { QueryClient } from '@tanstack/react-query'
import { shouldRetryQuery } from '@/lib/mastodonFetch'
import { PERSIST_GC_TIME } from '@/lib/queryPersister'

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60 * 1000, // Data is fresh for 1 minute
            gcTime: PERSIST_GC_TIME, // 24h — long enough for restored queries to survive until refetch
            refetchOnWindowFocus: false, // Don't refetch on window focus
            refetchOnReconnect: true, // Default, explicit for offline persistence behavior
            // Retry failed requests once, except UnsafeUrlError (validation
            // failures aren't going to become safe on retry).
            retry: shouldRetryQuery,
        },
    },
})
